import { createPortal } from 'react-dom'

export * from './decorative'
export * from './forms'
export * from './hooks'
export * from './layout'
export * from './nav'
export * from './styles'

export const Portal = ({ children }: any) => {
  return createPortal(children, document.body)
}

export {
  Accordion,
  AccordionDetails,
  AccordionSummary,
  Avatar,
  Button,
  ButtonGroup,
  Card,
  CardActionArea,
  CardContent,
  CardHeader,
  CardMedia,
  Checkbox,
  Chip,
  ClickAwayListener,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  FormControl,
  FormControlLabel,
  Grid,
  Grow,
  Icon,
  IconButton,
  InputLabel,
  ListSubheader,
  Menu,
  MenuItem,
  MenuList,
  Paper,
  Popover,
  Popper,
  Select,
  Slide,
  Snackbar,
  Switch,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  TextField,
  ThemeProvider,
  Typography
} from '@material-ui/core'

export {
  styled,
  makeStyles,
  useTheme
} from '@material-ui/core/styles'

export {
  Alert,
  AlertTitle,
  Autocomplete,
  createFilterOptions
} from '@material-ui/lab'
